// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3dMs_","selects":"Documents_selects__1ioDJ"};